export enum FlightDurationSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export type FlightDurationFlightTime = `${number}d ${number}h ${number}m` |
  `${number}d ${number}h` | `${number}h ${number}m` | `${number}h` | `${number}m` | null | undefined;
